<script lang="ts">
  import InDevelopment from "../../components/fallback/InDevelopment.svelte";
  import { useLocation } from "svelte-navigator";
  import {
    isTokenValid as checkToken,
    INTERNAL_ACCESS_KEY,
  } from "../../app/store/store-ui";

  const locationStore = useLocation();
  const location = $locationStore;
  const params = new URLSearchParams(location.search);
  const token =
    params.get(INTERNAL_ACCESS_KEY) ||
    localStorage.getItem(INTERNAL_ACCESS_KEY);
  const isTokenValid = checkToken(token);

  if (params.get(INTERNAL_ACCESS_KEY)) {
    localStorage.setItem(INTERNAL_ACCESS_KEY, token);
  }
</script>

{#if isTokenValid}
  <slot />
{:else}
  <InDevelopment />
{/if}
